import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowLeft, Lock } from "lucide-react";
import { NAV_ITEMS } from "@/lib/nav";
import { PageHeader } from "@/components/common/PageHeader";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";

/** Placeholder for modules that are architected but intentionally not enabled in this iteration. */
export default function ComingSoonPage({ moduleKey }) {
  const { t } = useTranslation();
  const location = useLocation();
  const item = NAV_ITEMS.find((i) => i.key === moduleKey) || NAV_ITEMS.find((i) => i.path === location.pathname);
  const key = item?.key || moduleKey || "approvals";
  const Icon = item?.icon || Lock;
  const name = t(`nav.${key}`);
  return (
    <div className="space-y-6" data-testid={`coming-soon-${key}`}>
      <PageHeader title={name} subtitle={t(`comingSoon.modules.${key}`)} eyebrow={t("common.comingSoon")} testId={`coming-soon-header-${key}`} />
      <div className="og-card flex flex-col items-start gap-4 p-6 md:flex-row md:items-center md:justify-between">
        <div className="flex items-start gap-4">
          <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-accent"><Icon className="h-5 w-5 text-primary" aria-hidden="true" /></div>
          <div>
            <div className="flex flex-wrap items-center gap-2">
              <h2 className="font-heading text-base font-semibold">{t("comingSoon.title", { module: name })}</h2>
              <Badge variant="outline" className="border-border bg-muted text-muted-foreground">{t("nav.soon")}</Badge>
            </div>
            <p className="mt-1 max-w-prose text-sm text-muted-foreground">{t("comingSoon.hint")}</p>
          </div>
        </div>
        <Button asChild variant="outline" className="bg-card" data-testid="coming-soon-back"><Link to="/app"><ArrowLeft className="mr-2 h-4 w-4" />{t("comingSoon.back")}</Link></Button>
      </div>
    </div>
  );
}
